<template>
    <div class="step-wrapper">
        <div class="step-header">
            <h2 class="step-title">What is your school start date?</h2>
        </div>

        <div class="step-body">
            <v-menu
                v-model="dateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="formattedDate"
                        label="Start Date"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        outlined
                        v-bind="attrs"
                        v-on="on"
                        class="date-field"
                    />
                </template>
                <v-date-picker
                    v-model="moveInDate"
                    :min="minDate"
                    @input="dateMenu = false"
                    color="primary"
                />
            </v-menu>
            <p class="date-disclaimer">If you're not sure of the exact date, try to estimate.</p>
        </div>

        <div class="step-footer">
            <v-btn
                color="primary"
                depressed
                block
                height="50"
                :disabled="!moveInDate"
                @click="onNext"
                class="next-btn"
            >
                Next
            </v-btn>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MoveInDateStep',

    data() {
        return {
            dateMenu: false
        };
    },

    computed: {
        moveInDate: {
            get() {
                return this.$store.getters['Questionnaire/getAnswer']('moveInDate');
            },
            set(value) {
                this.$store.dispatch('Questionnaire/setAnswer', {
                    key: 'moveInDate',
                    value
                });
            }
        },
        minDate() {
            return new Date().toISOString().substr(0, 10);
        },
        formattedDate() {
            if (!this.moveInDate) return '';
            const date = new Date(this.moveInDate + 'T00:00:00');
            return date.toLocaleDateString('en-US', {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            });
        }
    },

    methods: {
        onNext() {
            if (this.moveInDate) {
                this.$emit('next');
            }
        }
    }
};
</script>

<style scoped>
.step-wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.step-header {
    text-align: center;
    margin-bottom: 32px;
}

.step-title {
    font-size: 24px;
    font-weight: 700;
    color: #333;
}

.step-body {
    flex: 1;
}

.date-field {
    max-width: 300px;
    margin: 0 auto;
}

.date-disclaimer {
    text-align: center;
    font-size: 14px;
    color: #666;
    margin-top: 12px;
}

.step-footer {
    margin-top: auto;
    padding-top: 24px;
}

.next-btn {
    font-weight: 600;
    text-transform: none;
    font-size: 16px;
    border-radius: 8px;
}
</style>
